import { errorSWAL, successSWAL } from "src/components/SweetAlert";
import i18n from "src/i18n";
import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_SUCCESS,
  DELETE_USER,
  DELETE_USER_FAIL,
  DELETE_USER_SUCCESS,
  GET_SINGLE_USER,
  GET_SINGLE_USER_FAIL,
  GET_SINGLE_USER_SUCCESS,
  GET_USERS_FAIL,
  GET_USERS_LIST,
  GET_USERS_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_SUCCESS,
  GET_USER_DETAILS_REQUEST,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAIL,
  APPROVE_USER_REQUEST,
  APPROVE_USER_SUCCESS,
  APPROVE_USER_FAIL,
  RESEND_APPROVE_MAIL_REQUEST,
  RESEND_APPROVE_MAIL_SUCCESS,
  RESEND_APPROVE_MAIL_FAIL,
  APPROVE_USER_BY_SUPER_ADMIN_REQUEST,
  APPROVE_USER_BY_SUPER_ADMIN_SUCCESS,
  APPROVE_USER_BY_SUPER_ADMIN_FAIL,
  INVITE_USER_REQUEST,
  INVITE_USER_SUCCESS,
  INVITE_USER_FAIL,
  GET_USER_INVITE_REQUEST,
  GET_USER_INVITE_SUCCESS,
  GET_USER_INVITE_FAIL,
  APPROVE_USER_INVITE_REQUEST,
  APPROVE_USER_INVITE_SUCCESS,
  APPROVE_USER_INVITE_FAIL,
  RESEND_INVITE_MAIL_SUCCESS,
  RESEND_INVITE_MAIL_FAIL,
  RESEND_INVITE_MAIL_REQUEST,
  EDIT_USER_INFO_REQUEST,
  EDIT_USER_INFO_SUCCESS,
  GET_FILE_REQUEST,
  GET_FILE_SUCCESS,
  GET_FILE_FAIL,
} from "src/constants/types";
import adapter from "src/adapter/header";
import { with_auth } from "src/adapter";
import { toast } from "react-toastify";
import { buildApiUrl } from "src/utils/apiBaseUrl";
import { toDataURL } from "src/utils";

export const getFile = (id) => async (dispatch) => {
  if (!id) {
    return dispatch({
      type: GET_FILE_SUCCESS,
      payload: undefined,
    });
  }

  dispatch({ type: GET_FILE_REQUEST });

  try {
    toDataURL(
      buildApiUrl(`file/${id}`),
      function (dataUrl) {
        dispatch({
          type: GET_FILE_SUCCESS,
          payload: dataUrl,
        });
      }
    );
  } catch (e) {
    dispatch({ type: GET_FILE_FAIL, payload: e.data?.Status });
  }
};

export const editUserInfo = (data) => async (dispatch) => {
  dispatch({ type: EDIT_USER_INFO_REQUEST });

  try {
    const result = await adapter({
      url: "/user/edit-info",
      method: "PUT",
      data,
      headers: with_auth(),
    });

    dispatch({ type: EDIT_USER_INFO_SUCCESS, payload: result });
    toast.success(i18n.t("swal.success"), {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    });
  } catch (e) {
    dispatch({ type: EDIT_USER_INFO_SUCCESS, payload: e.data?.Status });

    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
  }
};

export const approveUserInvite = (data) => async (dispatch) => {
  dispatch({ type: APPROVE_USER_INVITE_REQUEST });
  try {
    const result = await adapter({
      url: "/user/invite/approve",
      method: "POST",
      data,
      headers: with_auth(),
    });
    dispatch({ type: APPROVE_USER_INVITE_SUCCESS, payload: result });

    return Promise.resolve(result.Data);
  } catch (e) {
    dispatch({ type: APPROVE_USER_INVITE_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject(e);
  }
};

export const getUserInvite = (Token) => async (dispatch) => {
  dispatch({ type: GET_USER_INVITE_REQUEST });
  try {
    const result = await adapter({
      url: "/user/invite",
      method: "GET",
      params: {
        Token,
      },
      headers: with_auth(),
    });
    dispatch({ type: GET_USER_INVITE_SUCCESS, payload: result.Data });

    return Promise.resolve(result.Data);
  } catch (e) {
    dispatch({ type: GET_USER_INVITE_FAIL, payload: e.data?.Status });

    return Promise.reject(e);
  }
};

export const inviteUser = (data) => async (dispatch) => {
  dispatch({ type: INVITE_USER_REQUEST });
  try {
    const result = await adapter({
      url: "/user/invite",
      method: "POST",
      data,
      headers: with_auth(),
    });
    dispatch({ type: INVITE_USER_SUCCESS, payload: result });

    return Promise.resolve();
  } catch (e) {
    dispatch({ type: INVITE_USER_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject(e);
  }
};

export const approveUserBySuperAdmin = (UserId) => async (dispatch) => {
  dispatch({ type: APPROVE_USER_BY_SUPER_ADMIN_REQUEST });
  try {
    const result = await adapter({
      url: "/user/approve/super-admin",
      method: "POST",
      data: {
        UserId,
      },
      headers: with_auth(),
    });
    dispatch({ type: APPROVE_USER_BY_SUPER_ADMIN_SUCCESS, payload: result });

    return Promise.resolve();
  } catch (e) {
    dispatch({
      type: APPROVE_USER_BY_SUPER_ADMIN_FAIL,
      payload: e.data?.Status,
    });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject(e);
  }
};

export const resendInviteMail = (UserId) => async (dispatch) => {
  dispatch({ type: RESEND_INVITE_MAIL_REQUEST });
  try {
    const result = await adapter({
      url: "/user/resend-invite-email",
      method: "POST",
      data: {
        UserId,
      },
      headers: with_auth(),
    });
    dispatch({ type: RESEND_INVITE_MAIL_SUCCESS, payload: result });

    return Promise.resolve();
  } catch (e) {
    dispatch({ type: RESEND_INVITE_MAIL_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject(e);
  }
};

export const resendApproveMail = (UserId) => async (dispatch) => {
  dispatch({ type: RESEND_APPROVE_MAIL_REQUEST });
  try {
    const result = await adapter({
      url: "/user/resend-approve-email",
      method: "POST",
      data: {
        UserId,
      },
      headers: with_auth(),
    });
    dispatch({ type: RESEND_APPROVE_MAIL_SUCCESS, payload: result });

    return Promise.resolve();
  } catch (e) {
    dispatch({ type: RESEND_APPROVE_MAIL_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject(e);
  }
};

export const approveUser = (Token) => async (dispatch) => {
  dispatch({ type: APPROVE_USER_REQUEST });
  try {
    const result = await adapter({
      url: "/user/approve",
      method: "POST",
      data: {
        Token,
      },
      headers: with_auth(),
    });
    dispatch({ type: APPROVE_USER_SUCCESS, payload: result });

    return Promise.resolve(result.Data);
  } catch (e) {
    dispatch({ type: APPROVE_USER_FAIL, payload: e.data?.Status });

    return Promise.reject(e);
  }
};

export const getUsersList =
  (
    {
      pageNumber = 1,
      pageSize = 25,
      email = "",
      status = "",
      company = "",
      group = "",
      isDispetcher = "",
      externalCode = "",
    } = {},
    t
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_USERS_LIST });
    try {
      const result = await adapter({
        url: `/user`,
        method: "GET",
        headers: with_auth(),
        params: {
          PageSize: pageSize,
          PageNumber: pageNumber,
          Email: email,
          StatusId: status,
          IsDispetcher: isDispetcher,
          CompanyId: company,
          UserGroupId: group,
          ExternalCode: externalCode,
        },
      });

      dispatch({ type: GET_USERS_SUCCESS, payload: result.Data });
    } catch (e) {
      dispatch({ type: GET_USERS_FAIL, payload: e.data.Status });
      errorSWAL({
        text:
          e.data && e.data.Status && e.data.Status.Message
            ? e.data.Status.Message
            : i18n.t("swal.error"),
        confirmButtonText: i18n.t("utils.ok"),
      });
    }
  };

export const getSingleUser = (id) => async (dispatch) => {
  dispatch({ type: GET_SINGLE_USER });

  try {
    const result = await adapter({
      url: `/user/${id}`,
      method: "GET",
      headers: with_auth(),
    });

    dispatch({ type: GET_SINGLE_USER_SUCCESS, payload: result.Data.User });
  } catch (e) {
    dispatch({ type: GET_SINGLE_USER_FAIL, payload: e.data.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
  }
};

export const deleteUser = (id) => async (dispatch) => {
  dispatch({ type: DELETE_USER });
  try {
    const result = await adapter({
      url: `/user/${id}`,
      method: "DELETE",
      headers: with_auth(),
    });
    dispatch({ type: DELETE_USER_SUCCESS, payload: result });
    return Promise.resolve();
  } catch (e) {
    dispatch({ type: DELETE_USER_FAIL, payload: e.data?.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
    return Promise.reject();
  }
};

export const changeUserPassword = (data) => async (dispatch) => {
  dispatch({ type: CHANGE_PASSWORD });

  try {
    const result = await adapter({
      url: `/user/change-password`,
      method: "PUT",
      data: data,
      headers: with_auth(),
    });

    dispatch({ type: CHANGE_PASSWORD_SUCCESS, payload: result });
    successSWAL({
      title: i18n.t("swal.success"),
      confirmButtonText: i18n.t("utils.ok"),
    });
  } catch (e) {
    dispatch({ type: CHANGE_PASSWORD_FAIL, payload: e.data?.Status });

    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
  }
};

export const resetUserPassword = (data) => async (dispatch) => {
  dispatch({ type: RESET_PASSWORD });

  try {
    const result = await adapter({
      url: `/user/reset-password`,
      method: "PUT",
      data: data,
      headers: with_auth(),
    });

    dispatch({ type: RESET_PASSWORD_SUCCESS, payload: result });
    successSWAL({
      title: i18n.t("swal.success"),
      confirmButtonText: i18n.t("utils.ok"),
    });
  } catch (e) {
    dispatch({ type: RESET_PASSWORD_FAIL, payload: e.data?.Status });

    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
  }
};

export const getUserDetails = () => async (dispatch) => {
  dispatch({ type: GET_USER_DETAILS_REQUEST });
  try {
    const result = await adapter({
      url: `/user/details`,
      method: "GET",
      headers: with_auth(),
    });

    dispatch({ type: GET_USER_DETAILS_SUCCESS, payload: result.Data.User });

    return result.Data.User;
  } catch (e) {
    dispatch({ type: GET_USER_DETAILS_FAIL, payload: e.data.Status });
    errorSWAL({
      text:
        e.data && e.data.Status && e.data.Status.Message
          ? e.data.Status.Message
          : i18n.t("swal.error"),
      confirmButtonText: i18n.t("utils.ok"),
    });
  }
};
